import { render, staticRenderFns } from "./DownloadOptions.vue?vue&type=template&id=148140ad&scoped=true"
import script from "./DownloadOptions.vue?vue&type=script&lang=ts"
export * from "./DownloadOptions.vue?vue&type=script&lang=ts"
import style0 from "./DownloadOptions.vue?vue&type=style&index=0&id=148140ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148140ad",
  null
  
)

export default component.exports